<template>
  <div class="home z-20 relative" v-if="payment && errorMessages.length">
    <Card> 
      <div class="max-w-buttonCover mx-auto mt-20 w-full">
        <p class="mb-8 text-black text-18" v-if="currentErrorState" v-html="currentErrorState.message"></p>
        <p class="mb-8 text-black text-18" v-else>Error</p>
        <a href="https://tinaba.it" class="block w-full bg-primary text-white font-bold py-2 px-4 rounded-20">  {{ $t("payment-success-visit-tinaba") }} </a>
      </div>
    </Card>
    <router-link :to="`/${payment.id}`" class="underline font-black text-14 text-white mt-24 mb-50 inline-block"> {{ $t("payment-code-goback") }}</router-link>
  </div>
</template>
<script>
import Card from '@/components/Card.vue'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'Error',
  components: {
    Card
  },
  methods: {
    ...mapActions('linkToPay', ['fetchErrorMessages'])
  },
  computed: {
    ...mapState('linkToPay', ['payment', 'errorMessages']),
    currentErrorState () {
      return this.errorMessages.find(({ code }) => this.payment.errorCode === code)
    }
  },
  created () {
    this.fetchErrorMessages()
  }
}
</script>